import React from "react";
import { Box } from "../../../../components";
import { useCustomTranslation } from "../../../../helpers/translateHelpers";
import { renderDate } from "../../../../helpers/dayjsHeleprs";
import { CPOrderDetail } from "../../../../api/models/unified";

interface Props {
  orderDetail: CPOrderDetail;
}

const OrderInfoBox: React.FC<Props> = (props): React.ReactElement => {
  const { orderDetail } = props;
  const { tOrder } = useCustomTranslation();

  return (
    <Box
      cols={2}
      title={tOrder("basic_info")}
      items={[
        {
          label: tOrder("customer"),
          value: orderDetail.customerName,
        },
        {
          label: tOrder("invoice_customer"),
          value: orderDetail.invoiceCustomerName,
          // hidden: !orderDetail.invoiceCustomerName,
        },
        {
          label: tOrder("state"),
          value: tOrder(`state_${orderDetail.state}`),
        },
        {
          label: tOrder("owner"),
          value: orderDetail.ownerName,
        },
        {
          label: tOrder("category"),
          value: orderDetail.categoryName,
        },
        {
          label: tOrder("contactPerson"),
          value: orderDetail.contactPersonName,
        },
        {
          label: tOrder("address"),
          value: orderDetail.oneLinerAddress,
        },
        {
          label: tOrder("created"),
          value: renderDate(orderDetail.created),
        },
        {
          label: tOrder("completed"),
          value: orderDetail.completedAt && renderDate(orderDetail.completedAt),
        },
        {
          label: tOrder("problemDescriptionFromCustomer"),
          value: orderDetail.problemDescriptionFromCustomer,
          isMultiLine: true,
        },
      ]}
    />
  );
};

export default OrderInfoBox;
